import { type EntitiesCategories } from '../../../states/entities/categories';
import { type CategoryState } from '../../../states/entities/categories';
import { type CategoryId } from '../../../states/entities/categories';
import { type StateType } from '../../../states/index';
import { type Selector } from '../../../types/selectors';
import { getCategoryIdFromProps } from '../../_propsGetters_';
import { selectEntitiesState } from '../entitiesPrimary.selector';

const emptyObject = {};

export const selectEntitiesCategories: Selector<EntitiesCategories> = (state: StateType) =>
  selectEntitiesState(state).categories ?? emptyObject;

//#region state.entities.categories
export type EntitiesCategoriesSelectorProps = {
  categoryId?: CategoryId;
};

export const selectEntitiesCategoriesEntity: Selector<CategoryState | undefined> = (
  state: StateType,
  props: EntitiesCategoriesSelectorProps = {},
) => {
  const categoryId = getCategoryIdFromProps(state, props);

  if (categoryId) {
    return selectEntitiesCategories(state)[categoryId];
  }
};
//#endregion

//#region state.entities.categories[categoryId]
export const selectEntitiesCategoriesEntityCategoryId: Selector<CategoryId | undefined> = (
  state: StateType,
  props: EntitiesCategoriesSelectorProps = {},
) => selectEntitiesCategoriesEntity(state, props)?.categoryId;

export const selectEntitiesCategoriesEntityCategoryName: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesCategoriesSelectorProps = {},
) => selectEntitiesCategoriesEntity(state, props)?.categoryName;

export const selectEntitiesCategoriesEntityTournaments: Selector<Array<number> | undefined> = (
  state: StateType,
  props: EntitiesCategoriesSelectorProps = {},
) => selectEntitiesCategoriesEntity(state, props)?.tournaments;

export const selectEntitiesCategoriesEntityMainMatchCount: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesCategoriesSelectorProps = {},
) => selectEntitiesCategoriesEntity(state, props)?.mainMatchCount;

export const selectEntitiesCategoriesEntityLiveMatchCount: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesCategoriesSelectorProps = {},
) => selectEntitiesCategoriesEntity(state, props)?.liveMatchCount;

export const selectEntitiesCategoriesEntityTvMatchCount: Selector<number | undefined> = (
  state: StateType,
  props: EntitiesCategoriesSelectorProps = {},
) => selectEntitiesCategoriesEntity(state, props)?.tvMatchCount;

export const selectEntitiesCategoriesEntityFlag: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesCategoriesSelectorProps = {},
) => selectEntitiesCategoriesEntity(state, props)?.flag;

export const selectEntitiesCategoriesEntityWarning: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesCategoriesSelectorProps = {},
) => selectEntitiesCategoriesEntity(state, props)?.warning;

export const selectEntitiesCategoriesEntityPrematchPromo: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesCategoriesSelectorProps = {},
) => selectEntitiesCategoriesEntity(state, props)?.prematchPromo;

export const selectEntitiesCategoriesEntityLivePromo: Selector<string | undefined> = (
  state: StateType,
  props: EntitiesCategoriesSelectorProps = {},
) => selectEntitiesCategoriesEntity(state, props)?.livePromo;
//#endregion
